class CartItems extends HTMLElement {
    constructor() {
        super();

        this.cartCountDown = document.getElementById(`CartCountdown-${this.dataset.section}`)
        this.giftCardElement = document.getElementById('is-a-gift')
        this.giftCardButton = document.getElementById('cart-gift-wrapping')
        this.removeButtons = document.querySelectorAll('[data-cart-remove]')
        this.toCheckoutButton = document.getElementById('cart-checkout')
        this.couponCodeInput = document.getElementById('cart-coupon-code')
        this.cartNoteInput = document.getElementById('cart-note')
        this.checkTerms = document.getElementById('cart_conditions')

        this.toCheckoutButton?.addEventListener('click', this.handleToCheckoutPage.bind(this))

        this.initDiscountCode()
        this.initToCheckoutButtonDisabling()
        this.initCartCountdown()
        if (this.giftCardElement) this.initGiftCardElement()
        this.initGiftCardManipulation()
  }

    initGiftCardElement() {
        const isChecked = this.giftCardButton?.dataset.isChecked
        if (isChecked === 'true') {
            const variantId = this.giftCardButton?.dataset.giftId
            const giftCardRemoveButton = document.querySelector(`[data-cart-remove-id="${variantId}"]`)
            const giftCardQuantityInput = document.querySelector(`[data-cart-quantity-id="${variantId}"]`)

            this.giftCardElement.style.display = 'none'
            giftCardRemoveButton?.addEventListener('click', () => {
                this.giftCardButton.dataset.isChecked = 'false'
            })

            giftCardQuantityInput?.addEventListener('change', (e) => {
                const value = Number(e.target.value)
                if (value  <= 0) {
                    this.giftCardButton.dataset.isChecked = 'false'
                }
            })
        } else {
          this.giftCardElement.style.display = 'flex'
        }
    }

    initGiftCardManipulation() {
        if (this.giftCardButton) {
            this.giftCardButton.removeEventListener('click', this.onAddGiftCardClick.bind(this))
            this.giftCardButton.addEventListener('click', this.onAddGiftCardClick.bind(this))
        }
    }

    onAddGiftCardClick(e) {
        e.preventDefault()
        e.stopPropagation()
        this.giftCardButton.dataset.isChecked = 'true'
    }

    initToCheckoutButtonDisabling() {
        if (this.checkTerms) {
            window.addEventListener('load', () => {
                this.toCheckoutButton.disabled = !this.checkTerms.checked
            })
        }
    }

    async handleToCheckoutPage(e) {
        e.preventDefault()

        try {
            // Couponcode: een ingetypte maar nog niet toegepaste code eerst via de cart-API zetten
            // (zelfde weg als de Toepassen-knop; geen /discount/-omweg meer). Ongeldig = melden en niet doorgaan.
            const couponCode = (this.couponCodeInput?.value || '').trim()
            if (couponCode) {
                const result = await this.applyDiscountCode(couponCode)
                if (result && result.status === 'invalid') {
                    if (this.couponCodeInput) this.couponCodeInput.value = ''
                    this.discountMessage?.scrollIntoView({ block: 'center', behavior: 'smooth' })
                    return
                }
            }

            // saving cart note
            const cartNote = this.cartNoteInput?.value
            if (cartNote) {
                const cartNoteBody = JSON.stringify({ note: cartNote })
                const cartNoteRes = await fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body: cartNoteBody }})
                const text2 = await cartNoteRes.text()
            }

        } catch(error) {
            console.error(`Error: ${error.message}`)
        }

        let checkoutHref = this.toCheckoutButton.dataset.href;
        if (checkoutHref == null) {
            checkoutHref = `${window.routes?.root ? window.routes.root : ""}/checkout`;
        }
        
        window.location = checkoutHref;
    }

    // ---- KP 29-09-2026: kortingscode direct toepassen via de cart-API ----
    // POST /cart/update.js { discount: "CODE1,CODE2" } zet de codes op de winkelwagen (ze gaan mee naar de checkout);
    // cart.discount_codes[].applicable zegt of een code geldt. Een lege string haalt alle codes weg.
    initDiscountCode() {
        this.discountApplyButton = document.getElementById('cart-coupon-apply')
        this.discountMessage = document.getElementById('cart-coupon-message')
        this.discountApplied = document.getElementById('cart-coupon-applied')
        if (!this.couponCodeInput || !this.discountApplyButton) return

        this.discountApplyButton.addEventListener('click', (e) => {
            e.preventDefault()
            this.applyDiscountCode(this.couponCodeInput.value)
        })
        this.couponCodeInput.addEventListener('keydown', (e) => {
            // Enter in dit veld verstuurde voorheen het formulier = direct naar de checkout.
            if (e.key === 'Enter') {
                e.preventDefault()
                this.applyDiscountCode(this.couponCodeInput.value)
            }
        })
        this.discountApplied?.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-discount-remove]')
            if (!btn) return
            e.preventDefault()
            this.removeDiscountCode(btn.dataset.discountRemove)
        })
        // Na aantal wijzigen/verwijderen (theme.js vuurt 'cart-update' met de nieuwe cart) de codes en de kortingsregel bijwerken.
        document.addEventListener('cart-update', (e) => {
            const cart = e.detail
            if (cart && Array.isArray(cart.discount_codes)) {
                this.renderDiscountCodes(cart)
                this.syncSavingsRow(cart)
            }
        })
    }

    discountText(key, vars = {}) {
        const lang = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase()
        const t = {
            nl: {
                empty: 'Vul eerst een kortingscode in.',
                ok: 'Kortingscode {code} is toegepast: {amount} korting.',
                ok_checkout: 'Kortingscode {code} is toegepast. De korting wordt verrekend bij het afrekenen.',
                invalid: 'Kortingscode {code} is ongeldig of geldt niet voor deze winkelwagen.',
                removed: 'Kortingscode {code} is verwijderd.',
                error: 'Er ging iets mis. Probeer het opnieuw of vul de code in bij het afrekenen.'
            },
            de: {
                empty: 'Bitte geben Sie zuerst einen Gutscheincode ein.',
                ok: 'Gutscheincode {code} wurde angewendet: {amount} Rabatt.',
                ok_checkout: 'Gutscheincode {code} wurde angewendet. Der Rabatt wird an der Kasse verrechnet.',
                invalid: 'Gutscheincode {code} ist ungültig oder gilt nicht für diesen Warenkorb.',
                removed: 'Gutscheincode {code} wurde entfernt.',
                error: 'Etwas ist schiefgelaufen. Bitte erneut versuchen oder den Code an der Kasse eingeben.'
            },
            en: {
                empty: 'Please enter a discount code first.',
                ok: 'Discount code {code} applied: {amount} off.',
                ok_checkout: 'Discount code {code} applied. The discount will be calculated at checkout.',
                invalid: 'Discount code {code} is invalid or does not apply to this cart.',
                removed: 'Discount code {code} removed.',
                error: 'Something went wrong. Please try again or enter the code at checkout.'
            }
        }
        const dict = t[lang] || t.nl
        return (dict[key] || t.nl[key]).replace(/\{(\w+)\}/g, (m, k) => (vars[k] != null ? vars[k] : ''))
    }

    formatCents(cents) {
        try {
            // money_format bevat soms de valutacode ("€0.79 EUR"); in de melding alleen het bedrag, zoals in het overzicht.
            if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.money_format) return Shopify.formatMoney(cents, window.money_format).replace(/\s+[A-Z]{3}\s*$/, '')
        } catch (e) {}
        const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
        return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency }).format(cents / 100)
    }

    showDiscountMessage(text, kind) {
        if (!this.discountMessage) return
        this.discountMessage.textContent = text
        this.discountMessage.classList.toggle('is-ok', kind === 'ok')
        this.discountMessage.classList.toggle('is-error', kind === 'error')
        this.discountMessage.hidden = !text
    }

    // Codes die nu op de winkelwagen staan (alleen de geldige).
    currentDiscountCodes(cart) {
        return (cart.discount_codes || []).filter(d => d.applicable).map(d => d.code)
    }

    // Kortingsbedrag dat bij één code hoort: orderniveau + regelniveau.
    discountAmountForCode(cart, code) {
        const same = (t) => String(t || '').toLowerCase() === String(code).toLowerCase()
        let cents = 0
        for (const app of (cart.cart_level_discount_applications || [])) if (same(app.title)) cents += Number(app.total_allocated_amount || 0)
        for (const item of (cart.items || [])) {
            for (const alloc of (item.line_level_discount_allocations || [])) {
                if (alloc.discount_application && same(alloc.discount_application.title)) cents += Number(alloc.amount || 0)
            }
        }
        return cents
    }

    async postDiscount(codes) {
        const base = (window.routes && window.routes.cart_update_url) || '/cart/update'
        const res = await fetch(base.endsWith('.js') ? base : `${base}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: codes.join(',') })
        })
        if (!res.ok) throw new Error(`cart/update ${res.status}`)
        return res.json()
    }

    async applyDiscountCode(rawCode) {
        const code = String(rawCode || '').trim()
        if (!code) {
            this.showDiscountMessage(this.discountText('empty'), 'error')
            return { status: 'empty' }
        }
        this.discountApplyButton?.setAttribute('aria-busy', 'true')
        try {
            const before = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json()
            const existing = this.currentDiscountCodes(before).filter(c => c.toLowerCase() !== code.toLowerCase())
            let cart = await this.postDiscount([...existing, code])
            const entry = (cart.discount_codes || []).find(d => String(d.code).toLowerCase() === code.toLowerCase())
            if (!entry || !entry.applicable) {
                // Ongeldige code niet op de winkelwagen laten staan (anders meldt de checkout hem later opnieuw).
                if (entry) cart = await this.postDiscount(this.currentDiscountCodes(cart))
                this.showDiscountMessage(this.discountText('invalid', { code }), 'error')
                this.afterDiscountChange(cart)
                return { status: 'invalid', cart }
            }
            // Het antwoord van /cart/update.js mist titel en bedrag van de korting (gemeten 29-09-2026);
            // daarom het bedrag uit een verse /cart.js halen. Blijft het 0 (bv. gratis verzending), dan de terugvaltekst.
            let cents = this.discountAmountForCode(cart, entry.code)
            if (!(cents > 0)) {
                try {
                    const fresh = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })).json()
                    cents = this.discountAmountForCode(fresh, entry.code)
                    cart = fresh
                } catch (e) {}
            }
            this.showDiscountMessage(cents > 0
                ? this.discountText('ok', { code: entry.code, amount: this.formatCents(cents) })
                : this.discountText('ok_checkout', { code: entry.code }), 'ok')
            if (this.couponCodeInput) this.couponCodeInput.value = ''
            this.afterDiscountChange(cart)
            return { status: 'ok', cart }
        } catch (error) {
            console.error(`Error: ${error.message}`)
            this.showDiscountMessage(this.discountText('error'), 'error')
            return { status: 'error' }
        } finally {
            this.discountApplyButton?.removeAttribute('aria-busy')
        }
    }

    async removeDiscountCode(code) {
        try {
            const before = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json()
            const rest = this.currentDiscountCodes(before).filter(c => c.toLowerCase() !== String(code).toLowerCase())
            const cart = await this.postDiscount(rest)
            this.showDiscountMessage(this.discountText('removed', { code }), 'ok')
            this.afterDiscountChange(cart)
        } catch (error) {
            console.error(`Error: ${error.message}`)
            this.showDiscountMessage(this.discountText('error'), 'error')
        }
    }

    afterDiscountChange(cart) {
        const codes = this.currentDiscountCodes(cart)
        try {
            if (codes.length) localStorage.setItem('storedDiscount', codes.join(','))
            else localStorage.removeItem('storedDiscount')
        } catch (e) {}
        this.renderDiscountCodes(cart)
        this.refreshCartSection()
    }

    renderDiscountCodes(cart) {
        if (!this.discountApplied) return
        const removeText = this.discountApplied.dataset.removeText || 'Verwijderen'
        const icon = document.querySelector('template[data-discount-icon]')?.innerHTML || ''
        this.discountApplied.innerHTML = ''
        for (const code of this.currentDiscountCodes(cart)) {
            const li = document.createElement('li')
            li.className = 'kp-coupon-chip'
            li.innerHTML = icon
            const span = document.createElement('span')
            span.className = 'kp-coupon-chip-code'
            span.textContent = code
            const btn = document.createElement('button')
            btn.type = 'button'
            btn.className = 'kp-coupon-remove'
            btn.dataset.discountRemove = code
            btn.setAttribute('aria-label', `${removeText} ${code}`)
            btn.innerHTML = '&times;'
            li.append(span, btn)
            this.discountApplied.append(li)
        }
    }

    syncSavingsRow(cart) {
        document.querySelectorAll('[data-saved-discount-display]').forEach(li => {
            li.style.display = Number(cart.total_discount || 0) > 0 ? '' : 'none'
        })
    }

    // Regels, subtotaal, korting en totaal opnieuw ophalen (zelfde onderdelen als halo.updateCart in theme.js).
    async refreshCartSection() {
        const main = document.getElementById('main-cart-items')
        const sectionId = main?.dataset.id
        if (!sectionId) return
        try {
            const html = await (await fetch(`${window.location.pathname}?section_id=${sectionId}`, { cache: 'no-store' })).text()
            const doc = new DOMParser().parseFromString(html.replaceAll('cart-coupon-discount', 'div'), 'text/html')
            const swap = (sel) => {
                const fresh = doc.querySelector(sel)
                if (!fresh) return
                document.querySelectorAll(sel).forEach(el => { el.innerHTML = fresh.innerHTML })
            }
            swap('[data-cart-content] .cart')
            swap('[data-cart-total] .cart-total-subtotal')
            swap('[data-cart-total] .cart-total-grandtotal')
            const freshSavings = doc.querySelector('[data-cart-total] .cart-total-savings')
            document.querySelectorAll('[data-cart-total] .cart-total-savings').forEach(el => {
                if (!freshSavings) return
                el.innerHTML = freshSavings.innerHTML
                el.style.display = freshSavings.style.display
                el.dataset.dis = freshSavings.dataset.dis
            })
            document.dispatchEvent(new CustomEvent('kp-cart-refreshed'))
        } catch (error) {
            console.error(`Error: ${error.message}`)
        }
    }

    initCartCountdown(){
        if(!this.cartCountDown) return;

        if(!this.cartCountDown.classList.contains('is-running')){
            const duration = this.cartCountDown.getAttribute('data-cart-countdown') * 60
            const element = this.cartCountDown.querySelector('.time');

            this.cartCountDown.classList.add('is-running');
            this.startTimerCartCountdown(duration, element);
        }
    }

    startTimerCartCountdown(duration, element){
        var timer = duration, minutes, seconds, text;

        var startCoundown = setInterval(() => {
            minutes = parseInt(timer / 60, 10);
            seconds = parseInt(timer % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
            text = minutes + ":" + seconds;

            element.innerText = text;

            if (--timer < 0) {
                clearInterval(startCoundown);
                this.cartCountDown.remove();
            }
        }, 1000);
    }
}

customElements.define('cart-items', CartItems);

class Accordion extends HTMLElement {
    constructor() {
        super();
        this.header = this.firstElementChild;
        this.content = this.lastElementChild;

        this.header.addEventListener('click', this.onSummaryClick.bind(this));
    }

    onSummaryClick(event) {
        event.preventDefault();
        this.hasAttribute('open') ? this.close() : this.open(event);
    }

    open(event) {
        this.setAttribute('open', true);
        this.setAttribute('aria-expanded', 'true');
        this.content.setAttribute('aria-hidden', 'false');
        $(this.content).slideDown()
    }

    close() {
        this.removeAttribute('open');
        this.setAttribute('aria-expanded', 'false');
        this.content.setAttribute('aria-hidden', 'true');
        $(this.content).slideUp()
    }
}

customElements.define('accordion-block', Accordion);

